import React, { useState } from 'react';
import PaidUsersTable from './_tabs/paid-users/tab';
import BulkProgressCalculation from './_tabs/bulk-progress/tab';
import { PageHeader } from '../../extras/PageLayout';
import { ResetFilterIcon } from '../../icons/enrolledUserIcons';

const TABS = [
  { key: 'list', label: 'List' },
  { key: 'bulk-progress', label: 'Bulk Progress' },
];

export default function EnrolledUsersPage() {
  const [activeTab, setActiveTab] = useState('list');
  const [isApplyDefaultFilter, setIsApplyDefaultFilter] = useState(false);
  const [, setMetricRefreshCount] = useState(0);

  return (
    <div>
      <PageHeader title="Enrolled Users" subtitle="Manage enrolled students" />

      {/* Tab bar */}
      <div style={{
        display: 'flex', gap: 32,
        borderBottom: '1px solid var(--border-light, #E5E7EB)',
        marginBottom: 0,
      }}>
        {TABS.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              style={{
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? 'var(--primary-main, #4F46E5)' : 'var(--text-secondary, #6B7280)',
                background: 'none', border: 'none',
                borderBottom: isActive ? '2px solid var(--primary-main, #4F46E5)' : '2px solid transparent',
                padding: '10px 0', cursor: 'pointer',
                transition: 'color 150ms ease, border-color 150ms ease',
                whiteSpace: 'nowrap',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Filter toolbar — only for list tab */}
      {activeTab === 'list' && (
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', padding: '12px 0' }}>
          <button
            onClick={() => setIsApplyDefaultFilter(true)}
            style={{
              display: 'flex', gap: 6, alignItems: 'center',
              cursor: 'pointer', background: 'none', border: 'none', padding: 0,
              fontSize: 13, fontWeight: 600, color: 'var(--primary-main, #4F46E5)',
            }}
          >
            <ResetFilterIcon />
            Reset Filters
          </button>
        </div>
      )}

      <div style={{ padding: '12px 0 24px' }}>
        {activeTab === 'list' && (
          <PaidUsersTable
            isApplyDefaultFilter={isApplyDefaultFilter}
            setIsApplyDefaultFilter={setIsApplyDefaultFilter}
            setMetricRefreshCount={setMetricRefreshCount}
          />
        )}
        {activeTab === 'bulk-progress' && <BulkProgressCalculation />}
      </div>
    </div>
  );
}
